export default "__VITE_ASSET__gUESACYL__"